import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import "./DonutChart.css";

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

const DonutChart: React.FC = () => {
  const data = {
    labels: ["Accepted", "Pending", "Declined"],
    datasets: [
      {
        data: [55, 35, 15],
        backgroundColor: ["#43EB34", "#EBCE34", "#C00909"],
        hoverBackgroundColor: ["#43EB34", "#EBCE34", "#C00909"],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    cutout: "50%",
    plugins: {
      legend: {
        position: "bottom" as const,
      },
      datalabels: {
        display: true,
        color: "#000",
        font: {
          weight: "bold" as const,
          size: 18,
        },
        formatter: (value: number) => `${value}%`,
      },
    },
  };

  return (
    <div className="donutchart">
      <div className="donut__status">
        <div>
          <p>invite status</p>
          <h3>100</h3>
        </div>

        <div className="donut__s">
          <div>
            <p className="dot f"></p> <p className="dottext">Accepted</p>
          </div>
          <div>
            <p className="dot s"></p> <p className="dottext">Pending</p>
          </div>
          <div>
            <p className="dot t"></p> <p className="dottext">Declined</p>
          </div>
        </div>
      </div>
      <Doughnut data={data} options={options} />
    </div>
  );
};

export default DonutChart;
